<!-- app.vue -->
<template>
  <NuxtLayout>
    <NuxtPage :key="nuxtPageRenderKey" />
  </NuxtLayout>

  <!-- 전역 알림창 -->
  <GlobalConfirmDialog />

  <!-- 전역 토스트 -->
  <UiToastNotification />

  <!-- 로딩 스피너 -->
  <UiSpinner size="lg" label="로딩 중입니다..." :active="isLoading" />

  <!-- 전역 CollaborationTaskModal -->
  <CollaborationTaskModal />

  <!-- 전역 이미지 미리보기 (openImageModal → UiModal) -->
  <ImagePreviewModalHost />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import UiSpinner from '~/pages/components/UiSpinner.vue';
import CollaborationTaskModal from '~/pages/screens/task/home/comp/modals/CollaborationTaskModal.vue';
import ImagePreviewModalHost from '~/components/common/UI/ImagePreviewModalHost.vue';
import { useLoadingStore } from '~/composables/useLoadingStore';

const isLoading = useLoadingStore();
const route = useRoute();
const samePathRefreshKey = useState<number>('same-path-refresh-key', () => 0);
// lang만 붙는 재이동(?lang=)에서는 페이지를 부수지 않는다. 그 재생성 중에 이동이 취소되면 본문이 빈다.
const nuxtPageRenderKey = computed(() => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(route.query)) {
    if (key === 'lang' || value == null) continue;
    const values = Array.isArray(value) ? value : [value];
    for (const item of values) {
      if (item != null && item !== '') params.append(key, String(item));
    }
  }
  params.sort();
  const qs = params.toString();
  return `${route.path}${qs ? `?${qs}` : ''}::${samePathRefreshKey.value}`;
});
</script>
